module.exports = __webpack_public_path__ + "static/media/viva.147b4a1f.svg";